
import { FaAward } from 'react-icons/fa';
import { FaTasks } from "react-icons/fa";
import { VscVmRunning } from "react-icons/vsc";


const data = [
    {
        id: 1,
        icon: < FaAward />,
        title: 'Experience',
        desc: '1+ years'
    },
    {
        id: 2,
        icon: <FaTasks />,
        title: 'Projects',
        desc: '50+ Completed'
    },
    {
        id: 3,
        icon: <VscVmRunning />,
        title: 'Live',
        desc: '3+'
    }
]


export default data;
